/**
 * cfcs
 * Copyright (c) 2022-present NAVER Corp.
 * MIT license
 */
export const OBSERVERS_PATH = "__observers__";
export const COMPUTED_PATH = "__computed__";
export const CFCS_DETECTED_DEPENDENCIES_VERSION = 1;
export const CFCS_DETECTED_DEPENDENCIES = "__CFCS_DETECTED_DEPENDENCIES__";
